var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('img',{attrs:{"src":require("@/assets/img/phone.png"),"alt":""}}),_c('p',[_vm._v("请使用手机浏览器")])])
}]

export { render, staticRenderFns }